module.exports = __webpack_public_path__ + "static/media/logomarca512.137571d9.png";